// extracted by mini-css-extract-plugin
module.exports =  {"targetItem":"_9IaYdttvORfkZzDaHhV","targetContent":"npWaGcT0xixmsFs5FLWX"};